import React, {useEffect, useMemo} from 'react';
import {withStyles} from "@material-ui/core/styles";
import {connect} from "react-redux";
import {listSurveys, startSurvey} from "../../../../../state/actions/surveyActions";
import LoadingCircle from "../../../../util/common/LoadingCircle";
import SurveyOption from "../menu/SurveyOption";

const styles = {
  root:{
    display: "flex",
    flexDirection: "column",
    borderRadius: "4px",
    border: "1px solid #ddd",
    backgroundColor: "rgba(0, 62, 88, 0.025)",
  },
  row:{
    display: "flex",
    flexWrap: "wrap",
    textAlign: "initial",
  },
  column:{
    display: "flex",
    flexDirection: "column",
    flex: 1,
    borderRadius: "4px",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    margin: "-1px",
  },
  label:{
    fontSize: "1rem",
    fontWeight: "600",
    width: "15rem",
    padding: "0.5rem"
  },
};

function getNext(groupId, surveyGroupList){
  if(!groupId || !surveyGroupList){
    return null;
  }
  const group = surveyGroupList[groupId];
  if(!group){
    return null;
  }
  const next = group.info?.next;
  if(!next){
    return getNext(group.parent_group_id, surveyGroupList);
  }
  return next;
}

function getHelpIndex(survey, groupList, helpStart="4") {
  if(!survey){
    return null;
  }
  const group = groupList[survey.survey_group.id]

  const path = [...group.path.slice(1), group.id].map(i => {
    const g = groupList[i]
    return Object.values(groupList[g?.parent_group_id]?.children||{})
      .sort((a,b) => a.order - b.order)
      .findIndex(g2 => g.id === g2.id) + 1;
  })

  const order = Object.keys(group.surveys).indexOf(survey.id.toString()) + 1;
  if(!order){
    return null;
  }
  return [helpStart, ...path, order].join(".")
}

function NextSurvey(props) {
  const { folderId, surveyAttempt, mindfile, availableSurveys, surveyGroups, surveyGroupList, requiredBy, listSurveys, startSurvey, filterName, openDataView, nextSurveyCallback=()=>{}, classes } = props;
  const survey = availableSurveys?.[surveyAttempt.survey_id]
  const surveyId = survey?.id;
  const loading = !surveyGroups || Object.keys(surveyGroups).length === 0;
  const next = getNext(survey?.survey_group?.id, surveyGroupList);
  const nextId = next?.id;
  const nextHelp = useMemo(() => getHelpIndex(next, surveyGroupList), [next, surveyGroupList])
  const unlockedSurveys = useMemo(() => requiredBy?.[surveyId]?.map(req => availableSurveys?.[req.survey_id])
        .filter(s => !!s && s.id !== nextId &&
            // can't use s.locked since it is false if an attempt exists, we want to ensure that all requirements are actually fulfilled
            // !s.locked
            !s.survey_reqs?.find(r => availableSurveys[r.survey_id]?.status !== 1)
        ) || []
  , [surveyId, availableSurveys, requiredBy, nextId]);
  const unlockedHelp = useMemo(() => unlockedSurveys.map(s => getHelpIndex(s, surveyGroupList)), [unlockedSurveys, surveyGroupList])

  useEffect(() => {
    if(loading) {
      listSurveys(mindfile.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  if(loading){
    return <LoadingCircle />
  }

  if(unlockedSurveys.length === 0 && !next){
    return null;
  }

  return (
    <div className={classes.root}>
      {!next ? null :
        <div className={classes.row}>
          <div className={classes.label}>Next Assessment in Sequence:</div>
          <div className={classes.column}>
            <SurveyOption
              helpIndex={nextHelp}
              survey={next}
              startSurvey={(callback) => startSurvey(mindfile.id, folderId, next.id, (data) => {
                nextSurveyCallback();
                typeof(callback) !== "function" || callback(data);
              })}
              openDataView={openDataView}
              filterName={filterName}
            />
          </div>
        </div>
      }
      {unlockedSurveys.length === 0 ? null :
        <div className={classes.row}>
          <div className={classes.label}>Unlocked Assessment:</div>
          <div className={classes.column}>
            {unlockedSurveys.slice(0,1).map((survey, i) =>
              <SurveyOption
                helpIndex={unlockedHelp[i]}
                key={i}
                survey={survey}
                startSurvey={(callback) => startSurvey(mindfile.id, folderId, survey.id, (data) => {
                  nextSurveyCallback();
                  typeof(callback) !== "function" || callback(data);
                })}
                openDataView={openDataView}
                filterName={filterName}
              />
            )}
          </div>
        </div>
      }
    </div>
  );
}

const mapStateToProps = state => ({
  mindfile: state.mindfile,
  availableSurveys: state.surveyGroups.surveys,
  surveyGroups: state.surveyGroups.root,
  surveyGroupList: state.surveyGroups.groups,
  requiredBy: state.surveyGroups.requiredBy,
})

const mapDispatchToProps = {
  listSurveys,
  startSurvey,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NextSurvey));
